/*
|-------------------------------------------------------------------------------
| API modules/collaborations/collaboration/index.js
|-------------------------------------------------------------------------------
| The Vuex data store for request collaborations
*/

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

export const collaboration = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
